import Backbone from 'backbone'
import DeleteConfirmationTooltip from 'scoreboard/components/delete-confirmation-tooltip'
import Bookmark from './bookmark'
import bookmarks from './bookmarks'
import Tooltip from 'scoreboard/components/tooltip'
import appDisplay from 'scoreboard/components/app-display'
import DeleteConfirmation from 'scoreboard/components/delete-confirmation'
import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'
import $ from 'jquery'
import spectator from 'scoreboard/components/spectator'
import template from './bookmark-toggler.hbs'
import mobile from 'scoreboard/components/mobile'
import { isV5, isV6 } from 'scoreboard/components/version'

/**
 * A control that allows users to bookmark or un-bookmark the current screen
 */
var BookmarkToggler = Backbone.View.extend({

	events: {
		'click': 'click'
	},

	/**
	 * Allows the toggler to be extended (for slide options menu) and the url
	 * to be provided through the properties.  This takes precedence over options.url
	 */
	url: null,

	/**
	 * Optionally adds a label alongside the icon
	 * (e.g. the toggler is included in a menu)
	 *
	 * The value should be a i18n key that will be suffixed with '.on' or '.off'
	 * depending on the current state of the toggle.
	 */
	iconLabel: null,

	label: null,

	/**
	 * Initializes the toggler with the following options:
	 * @param {Backbone.Model} [options.spectated] the object currently being
	 * spectated, if there is one
	 * @param {String} options.url the URL of the bookmark
	 * @param {String|Function} options.label the label to give to the bookmark
	 * when creating it. If a function, it will not be called until creating the
	 * bookmark (in case the view isn't done loading yet)
	 * @param {Boolean} options.isMobile indicates if we're currently in the
	 * @param {Object|Function} [options.uiState] an object (or function that returns
	 * an object representing the current state of the UI (sorted columns, expanded
	 * timeline nodes, etc). Will be persisted when creating a bookmark so that the
	 * UI state can be reconstructed when the bookmark is loaded.
	 * mobile view
	 */
	initialize: function(options) {
		this.options = options || {}
		this.url = this.url || options.url
		this.label = this.label || this.options.label
	},

	render: function() {
		if (!this.options.el) {
			this.$el.html(this.template ? this.template() : template())
		}
		this.toggleBookmark()
		return this
	},

	// returns whether the current screen is bookmarked
	_isBookmarked: function() {
		return bookmarks.has(this._url())
	},

	// returns the URL that would be used with the bookmark
	_url: function() {
		var spectatorUrl
		// If we're viewing a Bookmark or Briefing, get the correct url
		if (spectator.getCurrent()) {
			spectatorUrl = spectator.getCurrent().get('url')
		}
		return this.url || spectatorUrl || Backbone.history.fragment
	},

	click: function() {
		if (this._isBookmarked()) {
			// If this toggler is contained within a tooltip, use a dialog for the
			// delete confirmation. Else, use a tooltip for that.
			if (this.$el.parents('.tooltip').length || mobile.isMobileOrientation()) {
				// Display a confirmation modal instead of tooltip since this has been
				// triggered from a tooltip already
				var confirmation = new DeleteConfirmation({
					message: i18n.get('common.delete.confirmation', i18n.get('bookmarks.bookmark'))
				})
				appDisplay.dialog(confirmation)
				confirmation.once('confirm', function() {
					this._delete()
					confirmation.trigger('done')
				}.bind(this))
			} else {
				this._deleteBookmarkTooltip && this._deleteBookmarkTooltip.remove()
				this._deleteBookmarkTooltip = new DeleteConfirmationTooltip({
					label: i18n.get('bookmarks.bookmark')
				}).render()
				this._tooltip = new Tooltip({
					content: this._deleteBookmarkTooltip.el,
					attachTo: this.el,
					placement: 'below',
					arrow: 'center',
					extraClass: 'delete-confirmation-tooltip'
				}).render()
				this.listenTo(this._deleteBookmarkTooltip, 'cancel delete', this._tooltip.remove.bind(this._tooltip))
				this.listenTo(this._deleteBookmarkTooltip, 'delete', this._delete.bind(this))

			}
		} else {
			new Bookmark({
				url: this._url(),
				// #25013 could be a function, so don't resolve it until now,
				// when we're creating the bookmark
				label: _.result(this, 'label'),
				type: 'bookmark',
				uiState: JSON.stringify(_.result(this.options, 'uiState'))
			}).save()
			bookmarks.add(this._url())
			this.toggleBookmark(true)
			this.trigger('toggle', true)
		}
	},

	toggleBookmark: function(isBookmarked) {
		isBookmarked = isBookmarked || this._isBookmarked()
		if (isV5()) {
			this.$('.icon-bookmark-filled').toggleClass('is-bookmarked', isBookmarked)
		}
		if (isV6()) {
			this.$('.button-covert a').toggleClass('is-selected', isBookmarked)
			this.$('.icon-bookmark').toggleClass('is-bookmarked', isBookmarked)
		}
		this.iconLabel && this.$('.label').text(this._labelText(isBookmarked))
	},

	_labelText(isBookmarked) {
		return this.iconLabel && i18n.get(`${this.iconLabel}.${isBookmarked ? 'on' : 'off'}`)
	},

	_delete: function() {
		this.toggleBookmark(false)
		bookmarks.remove(this._url())
		this.trigger('toggle', false)
		$.delete('api/bookmarks?url=' + this._url(), function() {
			// if we're deleting the bookmark currently being viewed, fire an
			// event so the bookmark can be removed from the nav pane.  We can
			// only trigger the event in this case because this is the only case
			// in which we have access to the Bookmark model or the bookmark ID
			if (this.options.spectated &&
					this.options.spectated.domainType === 'bookmark' &&
					this.options.spectated.get('url') === this._url()) {
				Backbone.trigger('delete:domain-object', this.options.spectated)
			}
		}.bind(this))
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this._tooltip], 'remove')
	}

})

export default BookmarkToggler

BookmarkToggler.__filename__ = 'bookmarks/bookmark-toggler.js'
